import React from 'react';

function Calendar({ color = '#335B70', ...props }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                fill={color}
                fillRule="evenodd"
                d="M17 11H7v2h10v-2Zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2Zm0 16H5V9h14v11Zm-2-5H7v2h10v-2Z"
                clipRule="evenodd"
            />
        </svg>
    );
}

export default React.memo(Calendar);
